import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AppRoutePaths } from '@core/constants';
import { NavigationService } from '@core/services/navigation.service';
import { LogService } from '@core/services/log.service';

@Injectable({ providedIn: 'root' })
export class ActiveWorkflowGuard {
  constructor(
    private router: Router,
    private navigationService: NavigationService,
    private logService: LogService,
  ) {}

  async canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const independentPaths: string[] = [
      AppRoutePaths.Default,
      AppRoutePaths.StartWorkflow,
      AppRoutePaths.Error,
      AppRoutePaths.NotFound,
    ];
    if (
      independentPaths.includes(route.routeConfig?.path ?? '') ||
      this.navigationService.hasActiveWorkflow
    ) {
      return true;
    }

    try {
      return this.router.parseUrl(await this.navigationService.initializeSession());
    } catch (error) {
      this.logService.error('[ActiveWorkflowGuard]initializeSession()', error);
      return this.router.createUrlTree(['/', AppRoutePaths.Error]);
    }
  }
}
